import {
    ADMIN_GET_TRANSACTION_SUB_TYPE_SUCCESS,
    ADMIN_GET_TRANSACTION_SUB_TYPE_FAILED,
    LOADING_ADMIN_GET_TRANSACTION_SUB_TYPE,
    RESET_ADMIN_GET_TRANSACTION_SUB_TYPE,
    NETWORK_ERROR_ADMIN_GET_TRANSACTION_SUB_TYPE,
} from "../types";

const initialState = {
    isLoading: false,
    failed: false,
    success: false,
    data: {},
    networkError: "",
    invalidRequest: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADMIN_GET_TRANSACTION_SUB_TYPE: {
            return {
                ...state,
                isLoading: true,
                failed: false,
                success: false,
                invalidRequest: false,
                data: {},
            };
        }
        case ADMIN_GET_TRANSACTION_SUB_TYPE_FAILED: {
            return {
                ...state,
                isLoading: false,
                failed: true,
                success: false,
                invalidRequest: false,
                data: action.payload,
            };
        }
        case ADMIN_GET_TRANSACTION_SUB_TYPE_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                failed: false,
                success: true,
                invalidRequest: false,
                data: action.payload,
            };
        }
        case NETWORK_ERROR_ADMIN_GET_TRANSACTION_SUB_TYPE: {
            return {
                ...state,
                isLoading: false,
                failed: true,
                success: false,
                invalidRequest: false,
                networkError: "Something went wrong. Check internet connection",
                data: {},
            };
        }
        case RESET_ADMIN_GET_TRANSACTION_SUB_TYPE: {
            return (state = initialState);
        }

        default:
            return state;
    }
};
